class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    this.debouncedOnSubmit2 = debounce((event) => {
      this.onSubmitHandler(event);
    }, 50);

    const facetForm = this.querySelector('form');
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    facetForm.addEventListener('input', (event) => {
      const name = event.target.name;

      if (name === 'filter.p.m.custom.hair_type') {
        this.debouncedOnSubmit2(event);
      } else {
        this.debouncedOnSubmit(event);
      }
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static getActiveFilterCount() {
    let totalActiveCount = 0;

    // Get all forms related to facet filters
    const forms = document.querySelectorAll('facet-filters-form form#FacetFiltersFormMobile');
    forms.forEach((form) => {
      const formData = new FormData(form);
      // Count active filter values (e.g., checked checkboxes, non-empty price inputs)
      formData.forEach((value, key) => {
        // Exclude sort_by and other non-filter fields if needed
        if (key.startsWith('filter.') && value) {
          totalActiveCount += 1;
        }
      });

      // Special handling for price range (min/max are considered as one filter if both are set)
      const minPrice = formData.get('filter.v.price.gte');
      const maxPrice = formData.get('filter.v.price.lte');
      if (minPrice || maxPrice) {
        totalActiveCount += 1; // Count price range as one filter
      }
    });

    return totalActiveCount;
  }

  static renderActiveFilterCount() {
    const count = FacetFiltersForm.getActiveFilterCount();
    const countElements = document.querySelectorAll('.facets__selected.total_results_count');
    countElements.forEach((element) => {
      element.textContent = `(${count})`;
      element.classList.toggle('hidden', count === 0);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getGridSection();
    const sectionsBlocks = FacetFiltersForm.getBlockSection();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    const url = `${window.location.pathname}?section_id=${sections[0].section}&${searchParams}`;
    const filterDataUrl = (element) => element.url === url;

    FacetFiltersForm.filterData.some(filterDataUrl)
      ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      : FacetFiltersForm.renderSectionFromFetch(url, event);

    if (sectionsBlocks && sectionsBlocks.length && sectionsBlocks[0].section){
      const url2 = `${window.location.pathname}?section_id=${sectionsBlocks[0].section}&${searchParams}`;
      const filterDataUrl2 = (element) => element.url === url2;

      FacetFiltersForm.filterData.some(filterDataUrl2)
        ? FacetFiltersForm.renderSectionFromCache2(filterDataUrl2, event)
        : FacetFiltersForm.renderSectionFromFetch2(url2, event);

    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromFetch2(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductFilterBlocksContainer(html);
      });
  }

  static renderSectionFromCache2(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductFilterBlocksContainer(html);
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductFilterBlocksContainer(html) {
    const hairTypeContainer = document.getElementById('hairTypeContainer');
    if (hairTypeContainer) {
      hairTypeContainer.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('hairTypeContainer').innerHTML;
        hairTypeContainer.classList.remove('light');
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #Facet-mobile-sort'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #Facet-mobile-sort'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        // currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.renderActiveFilterCount(); // Update count after rendering filters

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    // Ensure mobile sort summary is updated
    const mobileSortDetails = parsedHTML.querySelector('#Facet-mobile-sort');
    const currentMobileSortDetails = document.querySelector('#Facet-mobile-sort');
    if (mobileSortDetails && currentMobileSortDetails) {
      currentMobileSortDetails.innerHTML = mobileSortDetails.innerHTML;
    }
    setupDetailsListeners();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');
    const targetSummary = target.querySelector('.collection_filter_item_summary .facets__selected');
    const sourceSummary = source.querySelector('.collection_filter_item_summary .facets__selected');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    } else if (targetSummary) {
    // If no active values in source, hide the count
      targetSummary.classList.add('hidden');
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getGridSection() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ];
  }

  static getBlockSection() {
    const bannerElement = document.querySelector('#collection-banner');
    return bannerElement
      ? [{ section: bannerElement.dataset.id }]
      : [];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

  // Check if the event is triggered by a hair_type filter checkbox
    if (event.target.name === 'filter.p.m.custom.hair_type') {
      const hairTypeContainer = document.getElementById('hairTypeContainer');
      if (hairTypeContainer && !hairTypeContainer.classList.contains('light')) {
          hairTypeContainer.classList.add('light');
      }
    // Get the form containing the checkbox
      const form = event.target.closest('form');
    // Uncheck all other hair_type checkboxes in the same form
      const hairTypeCheckboxes = form.querySelectorAll('input[name="filter.p.m.custom.hair_type"]');
      hairTypeCheckboxes.forEach(checkbox => {
        if (checkbox !== event.target) {
          checkbox.checked = false;
        }
      });

    // Get current URL search parameters
      const currentUrl = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentUrl.search);

    // Remove existing hair_type filter from current parameters
      currentParams.delete('filter.p.m.custom.hair_type');
      currentParams.delete('page');
    // Add new hair_type filter if the checkbox is checked
      if (event.target.checked) {
        currentParams.set('filter.p.m.custom.hair_type', event.target.value);
      }

    // Submit the updated search parameters
      this.onSubmitForm(currentParams.toString(), event);
      FacetFiltersForm.renderActiveFilterCount();
    }
    // Check if the event is triggered by a bundle filter checkbox
    else if (event.target.name === 'filter.p.m.custom.bundle') {
    // Get the form containing the checkbox
      const form = event.target.closest('form');
    // Uncheck all other bundle checkboxes in the same form
      const bundleCheckboxes = form.querySelectorAll('input[name="filter.p.m.custom.bundle"]');
      bundleCheckboxes.forEach(checkbox => {
        if (checkbox !== event.target) {
          checkbox.checked = false;
        }
      });

    // Get current URL search parameters
      const currentUrl = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentUrl.search);

    // Remove existing bundle filter and page parameter from current parameters
      currentParams.delete('filter.p.m.custom.bundle');
      currentParams.delete('page');

    // Handle active class for .bundle_detail elements
      const bundleValue = event.target.checked ? event.target.value : null;
      const bundleDetails = document.querySelectorAll('.bundle_detail');
      bundleDetails.forEach(element => {
        if (bundleValue && element.getAttribute('data-bundle') === bundleValue) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });

    // Add new bundle filter if the checkbox is checked
      if (event.target.checked) {
        currentParams.set('filter.p.m.custom.bundle', event.target.value);
      }

    // Submit the updated search parameters
      this.onSubmitForm(currentParams.toString(), event);
      FacetFiltersForm.renderActiveFilterCount();
    }
    else if (event.target.name === 'sort_by') {
      // Get the form containing the checkbox
      const form = event.target.closest('form');
    // Uncheck all other sort checkboxes in the same form
      const sortCheckboxes = form.querySelectorAll('input[name="sort_by"]');
      sortCheckboxes.forEach(checkbox => {
        if (checkbox !== event.target) {
          checkbox.checked = false;
        }
      });

    // Get current URL search parameters
      const currentUrl = new URL(window.location.href);
      const currentParams = new URLSearchParams(currentUrl.search);

    // Remove existing sort option from current parameters
      currentParams.delete('sort_by');
      currentParams.delete('page');

    // Add new sort option if the checkbox is checked
      if (event.target.checked) {
        currentParams.set('sort_by', event.target.value);
      }

    // Submit the updated search parameters
      this.onSubmitForm(currentParams.toString(), event);
      FacetFiltersForm.renderActiveFilterCount();
    }
    else {
    // Original logic for other filters
      if (event.srcElement.className === 'mobile-facets__checkbox') {
     // Get parameters from FacetFiltersFormMobile
      const mobileFormParams = this.createSearchParams(event.target.closest('form'));

      // Get parameters from the form inside hairTypeFilter (or hairTypeContainer)
      const hairTypeFilterElement = document.querySelector('#hairTypeFilter') || document.querySelector('#hairTypeContainer');
      let hairTypeFormParams = '';
      if (hairTypeFilterElement) {
        const hairTypeForm = hairTypeFilterElement.querySelector('form');
        if (hairTypeForm) {
          hairTypeFormParams = this.createSearchParams(hairTypeForm);
        }
      }

      // Get parameters from the FacetSortForm
      let facetSortFormParams = '';
      const facetSortFormElement = document.querySelector('#FacetSortForm');
      if (facetSortFormElement) {
        const facetSortForm = facetSortFormElement.querySelector('form') || facetSortFormElement; // Check if #FacetSortForm is the form itself
        if (facetSortForm) {
          facetSortFormParams = this.createSearchParams(facetSortForm);
        }
      }

      // Combine parameters with &
      let searchParams = mobileFormParams;
      if (hairTypeFormParams) {
        searchParams = searchParams ? `${searchParams}&${hairTypeFormParams}` : hairTypeFormParams;
      }
      if (facetSortFormParams) {
        searchParams = searchParams ? `${searchParams}&${facetSortFormParams}` : facetSortFormParams;
      }

        // Remove page parameter from combined search parameters
        const params = new URLSearchParams(searchParams);
        params.delete('page');
        searchParams = params.toString();

        this.onSubmitForm(searchParams, event);
        FacetFiltersForm.renderActiveFilterCount();
      } else {
        const forms = [];
        const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        });

        // Remove page parameter from combined search parameters
        let searchParams = forms.join('&');
        const params = new URLSearchParams(searchParams);
        params.delete('page');
        searchParams = params.toString();

        this.onSubmitForm(searchParams, event);
        FacetFiltersForm.renderActiveFilterCount();
      }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    FacetFiltersForm.renderActiveFilterCount();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener('DOMContentLoaded', function () {
   // Use event delegation to handle keydown events for .facets__label input[type="checkbox"]
  document.addEventListener('keydown', function (event) {
       // Check if the event target matches a checkbox inside .facets__label
    if (
      event.target.matches('.facets__label input[type="checkbox"]') &&
      event.key === 'Enter'
    ) {
      event.preventDefault(); // Prevent form submission if inside a form
      event.target.click(); // Trigger the checkbox's click event
    }
  });
});


function setupDetailsListeners() {
  const detailsElements = document.querySelectorAll('.collection_filter_item, .mobile-facets__details_sub, .collection_filter_item_mobile, .sort_desktop');

  detailsElements.forEach((details) => {
    observer.unobserve(details); 
    details.removeEventListener('click', handleDetailsClick); 
    details.removeEventListener('toggle', handleDetailsToggle);
  });


  detailsElements.forEach((details) => {
    details.addEventListener('click', handleDetailsClick);
   if (details.classList.contains('collection_filter_item') || details.classList.contains('sort_desktop')) {
  details.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      console.log(event.target.tagName);
      if( event.target.tagName.toLowerCase() == 'summary' ){
      event.preventDefault();
      details.open = !details.open;
      handleDetailsToggle(event);
      }
    }
  });
}
    observer.observe(details); 
    if ((details.classList.contains('collection_filter_item') || details.classList.contains('sort_desktop')) && details.open) {
      handleDetailsFocus(details);
    }
  });

  function handleDetailsClick(e) {
    const details = e.currentTarget;
    if (details.classList.contains('collection_mobile_filters')) {
      e.preventDefault();
    }

    e.stopPropagation();

    if (details.classList.contains('collection_mobile_filters')) {
      if (details.open) {
        details.querySelectorAll('.mobile-facets__details_sub').forEach((nestedDetails) => {
          nestedDetails.open = false;
        });
        details.open = false;
      } else {
        details.open = true;
        detailsElements.forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.open) {
            if (
              !(otherDetails.classList.contains('mobile-facets__details_sub') &&
                details.classList.contains('collection_mobile_filters') &&
                details.contains(otherDetails))
            ) {
              otherDetails.open = false;
            }
          }
        });
      }
    } else {
      detailsElements.forEach((otherDetails) => {
        if (otherDetails !== details && otherDetails.open) {
          if (
            !(details.classList.contains('mobile-facets__details_sub') &&
              otherDetails.classList.contains('collection_mobile_filters') &&
              otherDetails.contains(details)) &&
            !(
              (details.classList.contains('sort_desktop') && otherDetails.classList.contains('sort_mobile')) ||
              (details.classList.contains('sort_mobile') && otherDetails.classList.contains('sort_desktop'))
            )
          ) {
            otherDetails.open = false;
          }
        }
      });
    }
  }

  function handleDetailsToggle(e) {
    const details = e.currentTarget;
    handleDetailsFocus(details);
    detailsElements.forEach((otherDetails) => {
      if (otherDetails !== details && otherDetails.open) {
        handleDetailsFocus(otherDetails);
      }
    });
  }

  document.removeEventListener('click', handleOutsideClick); // Remove existing listener
  document.addEventListener('click', handleOutsideClick);

  function handleOutsideClick(e) {
    if (!e.target.closest('.collection_filter_item, .mobile-facets__details_sub, .collection_filter_item_mobile, .sort_desktop')) {
      detailsElements.forEach((details) => {
        if (details.open) {
          details.open = false;
          if (details.classList.contains('collection_filter_item') || details.classList.contains('sort_desktop')) {
            handleDetailsFocus(details);
          }
        }
      });
    }
  }
}

const observerOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting && entry.target.open) {
      entry.target.open = false;
      if (entry.target.classList.contains('collection_filter_item') || entry.target.classList.contains('sort_desktop')) {
        handleDetailsFocus(entry.target);
      }
    }
  });
}, observerOptions);

document.addEventListener('DOMContentLoaded', () => {
  setupDetailsListeners();

  // Handle window resize to re-evaluate focus trapping
  window.addEventListener('resize', () => {
    const detailsElements = document.querySelectorAll('.collection_filter_item, .sort_desktop');
    detailsElements.forEach((details) => {
      if (details.open) {
        handleDetailsFocus(details);
      }
    });
  });
});

function handleDetailsFocus(details) {
  // Check if the viewport is in desktop mode (> 992px)
  const isDesktop = window.innerWidth > 992;
  const facetsDisplay = details.querySelector('.facets__display');
  const summary = details.querySelector('summary');

  if (details.open && isDesktop) {
    const focusableElements = getFocusableElements(facetsDisplay);

    if (!focusableElements.length) {
      summary.focus();
      return;
    }

    trapFocus(facetsDisplay, facetsDisplay.querySelector('input'));

    const handleKeydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        summary.focus();
      }

      if (event.target === first && event.shiftKey) {
        event.preventDefault();
        summary.focus();
      }
    };

    document.addEventListener('keydown', handleKeydown);
    
    details.dataset.keydownHandler = handleKeydown.toString();
  } else {
    removeTrapFocus(summary);

    if (details.dataset.keydownHandler) {
      const handler = eval(`(${details.dataset.keydownHandler})`);
      document.removeEventListener('keydown', handler);
      delete details.dataset.keydownHandler;
    }
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => !el.hasAttribute('disabled') && !el.closest('[hidden]'));
}